/**
 * Log apenas dos eventos do botão Transferir (para diagnóstico no mobile).
 * Exibido entre o conteúdo principal e o rodapé.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const MAX_ENTRIES = 30;

const TransferButtonLogContext = createContext(null);

function formatEntry(e) {
  return `[${e.at}] ${e.type}: ${e.message}`;
}

export function TransferButtonLogProvider({ children }) {
  const [entries, setEntries] = useState([]);

  const addLog = useCallback((type, message) => {
    const at = new Date().toLocaleTimeString('pt-BR', { hour12: false }) + '.' + String(Date.now() % 1000).padStart(3, '0');
    setEntries((prev) => {
      const next = [...prev, { at, type, message }];
      return next.slice(-MAX_ENTRIES);
    });
  }, []);

  const clearLog = useCallback(() => setEntries([]), []);

  return (
    <TransferButtonLogContext.Provider value={{ entries, addLog, clearLog }}>
      {children}
    </TransferButtonLogContext.Provider>
  );
}

export function useTransferButtonLog() {
  const ctx = useContext(TransferButtonLogContext);
  return ctx || { entries: [], addLog: () => {}, clearLog: () => {} };
}

export function TransferButtonLogPanel() {
  const { entries, clearLog } = useTransferButtonLog();
  const [copied, setCopied] = useState(false);

  const copyLog = useCallback(async () => {
    const text = entries.map(formatEntry).join('\n');
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.warn('[TransferButtonLog] clipboard failed:', err);
    }
  }, [entries]);

  if (entries.length === 0) return null;

  return (
    <div className="bg-gray-900 border-t border-purple-500/30 px-4 py-2 max-h-32 overflow-y-auto">
      <div className="flex items-center justify-between mb-1 gap-2">
        <span className="text-xs font-medium text-purple-300">Log botão Transferir (eventos)</span>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={copyLog}
            className="text-xs text-gray-500 hover:text-white"
          >
            {copied ? 'Copiado!' : 'Copiar'}
          </button>
          <button
            type="button"
            onClick={clearLog}
            className="text-xs text-gray-500 hover:text-white"
          >
            Limpar
          </button>
        </div>
      </div>
      <div className="font-mono text-[10px] space-y-0.5 text-gray-400">
        {entries.map((e, i) => (
          <div key={i} className={e.type === 'error' ? 'text-red-400' : e.type === 'handler' ? 'text-green-400' : ''}>
            [{e.at}] {e.type}: {e.message}
          </div>
        ))}
      </div>
    </div>
  );
}
